module.exports = __webpack_public_path__ + "media/images/pages/primary-teachers/barefoot-2017f80961d610d4e19493893306cd47.svg";